import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// ---------------------------------------------------------------------------------------------- //
// Animations
import animationsClouds from './component/AnimationsClouds';
new animationsClouds();

import animationsTextLines from './component/AnimationsTextLines';
new animationsTextLines('.wp-block-intro p');
new animationsTextLines('.timeline__intro p');

import animationsSite from './component/SiteAnimations';
animationsSite.createInstance([
	{
		observedSelector: '.pageContent > div:not(.featuredContent):not(.wp-block-media-text):not(.wp-block-intro):not(.timeline):not(.logoCarousel)',
		options: {
			rootMargin: '-150px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.featuredContent__main',
		ancestorSelector: '.featuredContent',
		options: {
			rootMargin: '-100px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.timeline__intro',
		ancestorSelector: '.timeline',
		options: {
			rootMargin: '0px 0px',
			threshold: .65
		}
	},
	{
		observedSelector: '.wp-block-media-text__content',
		options: {
			rootMargin: '0px 0px',
			threshold: .25
		}
	},
	{
		observedSelector: '.aioseo-location-box',
		options: {
			rootMargin: '0px 0px',
			threshold: .25
		}
	},
	{
		observedSelector: '.fleet__item',
		options: {
			rootMargin: '0px 0px',
			threshold: .8
		}
	},
	{
		observedSelector: '.wp-block-columns',
		options: {
			rootMargin: '0px 0px',
			threshold: .8
		}
	},
	{
		observedSelector: '.wp-block-intro',
		options: {
			rootMargin: '-280px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.logoCarousel',
		options: {
			rootMargin: '-150px 0px',
			threshold: 0
		}
	}
]);
// ---------------------------------------------------------------------------------------------- //


// ---------------------------------------------------------------------------------------------- //
// Carousels
import logoCarousel from './component/LogoCarousel/LogoCarousel';
logoCarousel('.logoCarousel__slides');

import testimonialCarousel from './component/TestimonialCarousel';
testimonialCarousel('.testimonialCarousel__slides');
// ---------------------------------------------------------------------------------------------- //

import tabGroup from './component/TabGroup';
new tabGroup();

import timeline from './component/Timeline';
new timeline();
